<div [formGroup]="form">
  <!-- Envio e frete: forma de envio -> forma de frete (cascata) -->
  <div class="sub-section-container sub-secao-transporte">
    <div class="sub-section-title">
      <mat-icon class="material-symbols-outlined">conveyor_belt</mat-icon>
      <span>Envio e frete</span>
    </div>

    <div class="row">
      <div class="col-12 col-md-4">
        <app-select-pesquisavel
          label="Forma de envio"
          [control]="formaEnvioControl"
          [offlineList]="formasEnvio"
          idField="idFormaEnvio"
          nameField="descricao"
          [isOptional]="true"
          emptyOptionLabel="Não definida"
          [disabled]="isSomenteLeitura"
          [hint]="formasEnvio.length ? '' : 'Nenhuma forma de envio cadastrada em Configurações ▸ Vendas.'"
          placeholder="Não definida">
        </app-select-pesquisavel>
      </div>

      <div class="col-12 col-md-4">
        <app-select-pesquisavel
          label="Forma de frete"
          [control]="formaFreteControl"
          [offlineList]="fretesDaForma"
          idField="idFormaFrete"
          nameField="descricao"
          [isOptional]="true"
          [disabled]="isSomenteLeitura || !temFormaEnvio"
          [hint]="temFormaEnvio && !fretesDaForma.length ? 'Esta forma de envio não tem serviços de frete cadastrados.' : ''"
          placeholder="Selecione...">
        </app-select-pesquisavel>
      </div>

      @if (!ehOrcamento) {
        <div class="col-12 col-md-4">
          <app-select-pesquisavel
            label="Frete por conta"
            [control]="modalidadeFreteControl"
            [offlineList]="modalidadesFrete"
            idField="id"
            nameField="descricao"
            [isOptional]="true"
            [disabled]="isSomenteLeitura"
            placeholder="Selecione...">
          </app-select-pesquisavel>
        </div>

        <!-- §3.1: rastreio e expedição só com forma de envio definida -->
        @if (temFormaEnvio) {
          <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Código de rastreamento</mat-label>
              <input matInput formControlName="codigoRastreamento" maxlength="60">
            </mat-form-field>
          </div>

          <div class="col-12 col-md-8">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>URL de rastreamento</mat-label>
              <input matInput formControlName="urlRastreamento" maxlength="500" placeholder="https://...">
            </mat-form-field>
          </div>

          @if (exibeExpedicao) {
            <div class="col-12 col-md-4 fileira-toggle">
              <mat-slide-toggle class="app-toggle-compact" formControlName="isEnviarExpedicao">
                Enviar para expedição
              </mat-slide-toggle>
            </div>
          }
        }
      }
    </div>
  </div>

  <!-- Transportador -->
  <div class="sub-section-container sub-secao-transporte">
    <div class="sub-section-title">
      <mat-icon class="material-symbols-outlined">local_shipping</mat-icon>
      <span>Transportador</span>
    </div>

    <div class="row">
      <div class="col-12 col-md-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Transportador</mat-label>
          <input matInput [value]="nomeTransportador" disabled
            [placeholder]="temFormaEnvio ? 'Definido pelo serviço de frete' : ''">
          <mat-icon matSuffix class="material-symbols-outlined icone-apoio"
            matTooltip="Vem do cadastro do serviço de frete escolhido.">lock</mat-icon>
        </mat-form-field>
      </div>
    </div>
  </div>

  <!-- Volumes: a tela edita um volume, como a NF-e de saída. Só no pedido: o orçamento não usa. -->
  @if (!ehOrcamento) {
  <div class="sub-section-container sub-secao-transporte" [formGroup]="volume">
    <div class="sub-section-title">
      <mat-icon class="material-symbols-outlined">package_2</mat-icon>
      <span>Volumes</span>
    </div>

    <div class="row">
      <div class="col-6 col-md-2">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Qtde</mat-label>
          <input matInput formControlName="quantidade" inputmode="numeric" [currencyMask]="mascaraInteira" class="num">
        </mat-form-field>
      </div>

      <div class="col-6 col-md-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Espécie</mat-label>
          <input matInput formControlName="especie" maxlength="60">
        </mat-form-field>
      </div>

      <div class="col-6 col-md-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Marca</mat-label>
          <input matInput formControlName="marca" maxlength="60">
        </mat-form-field>
      </div>

      <div class="col-6 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Numeração</mat-label>
          <input matInput formControlName="numeracao" maxlength="60">
        </mat-form-field>
      </div>

      <div class="col-6 col-md-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Peso bruto (kg)</mat-label>
          <input matInput formControlName="pesoBruto" inputmode="decimal" [currencyMask]="mascaraPeso" class="num">
        </mat-form-field>
      </div>

      <div class="col-6 col-md-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Peso líquido (kg)</mat-label>
          <input matInput formControlName="pesoLiquido" inputmode="decimal" [currencyMask]="mascaraPeso" class="num">
        </mat-form-field>
      </div>
    </div>
  </div>
  }
</div>
